export enum NotificationType {
  chewyLaunch = 'chewyLaunch',
  socialMedia = 'socialMedia',
  promoteProducts = 'promoteProducts',
  takeSurveys = 'takeSurveys',
  joinClubs = 'joinClubs',
  connectAccounts = 'connectAccounts',
  inviteAFriend = 'inviteAFriend',
  earnMoreRewards = 'earnMoreRewards',
  syncRewardsEarned = 'syncRewardsEarned',
  joinPromotedClubRewardsEarned = 'joinPromotedClubRewardsEarned',
  orderConfirmationRewardsEarned = 'orderConfirmationRewardsEarned',
  connectNewAccounts = 'connectNewAccounts',
  syncPurchases = 'syncPurchases',
  cashOutRewards = 'cashOutRewards',
  bestRewardsGeneric = 'bestRewardsGeneric',
  bestRewardsPersonalized = 'bestRewardsPersonalized',
  instantRewardsBlackFriday = 'instantRewardsBlackFriday',

  // Messaging Campaign - Old Notification Types:
  payoutConfirmed = 'payoutConfirmed',
  rewardsEarnedSummary = 'rewardsEarnedSummary',
  inviteAFriendRewardsEarned = 'inviteAFriendRewardsEarned',
  promoteProductsRewardsEarned = 'promoteProductsRewardsEarned',
  serverSideSyncComplete = 'serverSideSyncComplete',
  serverSideSyncFailed = 'serverSideSyncFailed',
  serverSideSyncStart = 'serverSideSyncStart',

  // Messaging Campaign - New Notification Types:
  orderReceiptMessage = 'orderReceiptMessage',
  postPurchaseConnectMessage = 'postPurchaseConnectMessage',
  reviewRequestMessage = 'reviewRequestMessage',
  membershipRewardReceiptMessage = 'membershipRewardReceiptMessage',
  surveyRewardReceiptMessage = 'surveyRewardReceiptMessage',
  affiliateRewardReceiptMessage = 'affiliateRewardReceiptMessage',
  contentRewardReceiptMessage = 'contentRewardReceiptMessage',
  expiringRewardReminderMessage = 'expiringRewardReminderMessage',
  reviewReceiptMessage = 'reviewReceiptMessage',
  reorderRequestMessage = 'reorderRequestMessage',
  productRecommendationsMessage = 'productRecommendationsMessage',
  rewardRecommendationsMessage = 'rewardRecommendationsMessage',
}

/**
 * Only messages with the following notification types are shown in the Mobile App Inbox
 */
export const inboxNotificationTypes = [
  NotificationType.orderReceiptMessage,
  NotificationType.postPurchaseConnectMessage,
  NotificationType.reviewRequestMessage,
  NotificationType.membershipRewardReceiptMessage,
  NotificationType.surveyRewardReceiptMessage,
  NotificationType.affiliateRewardReceiptMessage,
  NotificationType.contentRewardReceiptMessage,
  // NotificationType.expiringRewardReminderMessage,
  NotificationType.reviewReceiptMessage,
  NotificationType.reorderRequestMessage,
  NotificationType.productRecommendationsMessage,
  NotificationType.rewardRecommendationsMessage,
];
